import { createSelector } from 'reselect';
import { SelectedCustomerSelector } from './customer.selectors';
import { UserSecurityAttributesSelector } from 'invision-core/src/components/session/session.selectors';
import { hasAccess } from 'invision-core/src/components/security/permission.service';
import { SUBSCRIBER_PASSWORD_CHALLENGE_RESPONSE_ACCESS } from '../../security.attributes';
import { createImmutableSelector } from 'invision-core/src/utilities/create.immutable.selector';
export var IsFetchingChallengeAnswerSelector = createSelector([SelectedCustomerSelector], function (selectedCustomer) {
  return selectedCustomer.challenge.isFetchingChallengeAnswer;
});
export var ChallengeAnswerSelector = createSelector([SelectedCustomerSelector], function (selectedCustomer) {
  return selectedCustomer.challenge.data;
});
export var HasSubscriberPasswordAccessSelector = createImmutableSelector([UserSecurityAttributesSelector], function (securityAttributes) {
  return hasAccess(securityAttributes, SUBSCRIBER_PASSWORD_CHALLENGE_RESPONSE_ACCESS);
});